import type {
  AudiobookDecryptedFileMap,
  AudiobookManifest, AudiobookTrackMetadata } from '../types/audiobooks';
import makeLogger from '../utils/makeLogger';
import type { AudiobookFileStore, DownloadTracksOptions } from './stores/types';

const logger = makeLogger(__filename);

async function downloadTracks(
  docId: string,
  manifest: AudiobookManifest,
  encryptedFileMap: AudiobookDecryptedFileMap | null,
  options: DownloadTracksOptions = {},
): Promise<{ [id: string]: AudiobookTrackMetadata; }> {
  const { shouldBypassCache = false, trackIdsInPriorityOrder } = options;

  logger.warn('Audiobook downloading not supported on web platform', {
    docId,
    manifestCount: Object.keys(manifest).length,
    hasEncryptedFileMap: Boolean(encryptedFileMap),
    shouldBypassCache,
    trackIdsInPriorityOrder,
  });

  return {};
}

async function removeTracksByIds(trackIds: string[]): Promise<void> {
  logger.debug('removeTracksByIds called on web platform (no-op)', { trackIds });
}

/**
 * Loads cached audiobook tracks by their IDs.
 * No-op on web platform as audiobook caching is not supported.
 */
function loadFromCache(trackIds: string[]): { [id: string]: AudiobookTrackMetadata; } {
  logger.debug('loadFromCache called on web platform (no-op)', { trackIds });
  return {};
}

async function clearAudiobookCache(): Promise<void> {
  logger.debug('clearAudiobookCache called on web platform (no-op)');
}

export const audiobookFileStore: AudiobookFileStore = {
  downloadTracks,
  loadFromCache,
  removeTracksByIds,
  clearAudiobookCache,
};
